import { Component, OnInit } from '@angular/core';
import { PulsingTooltipComponent } from "src/app/components/pulsing-tooltip/pulsing-tooltip.component";
import { MaterialModule } from "src/app/app.materials";
import { FormsModule } from '@angular/forms';
@Component({
  selector: 'app-custom-help',
  templateUrl: './custom-help.component.html',
  styleUrls: ['./custom-help.component.scss'],
  imports: [PulsingTooltipComponent, MaterialModule, FormsModule],
  standalone: true,
})
export class CustomHelpComponent implements OnInit {

  numComp = 30;
  constructor() { }

  ngOnInit(): void {
  }

}
